var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"1"}},[_c('v-card-title',{staticClass:"pt-6 pb-6"},[_vm._v(" "+_vm._s(_vm.$t('standings-table'))+" "),_c('v-spacer'),_c('v-btn',{staticClass:"mr-1",attrs:{"icon":"","to":{
        name: 'GroupStatistics',
        params: {
          competitionId: _vm.$route.params.competitionId,
          groupId: _vm.groupId
        }
      }}},[_c('v-icon',[_vm._v("mdi-chart-bar")])],1),_c('v-btn',{attrs:{"loading":_vm.loading,"color":"primary","data-index":"1","icon":""},on:{"click":function($event){return _vm.generateStandingSnapshot()}}},[_c('v-icon',[_vm._v("mdi-cached")])],1)],1),_c('v-card-text',[_c('standings-table',{attrs:{"table":_vm.standingsTable}}),_c('small',{staticClass:"text-caption"},[_vm._v("Current table ID: "+_vm._s(_vm.currentTableId))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }